import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const UnderlineIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <rect fill={color} height="1.5" rx="0.75" width="10" x="3" y="13.5" />
    <path
      d="M11.5 2C12.0128 2 12.4355 2.3517 12.4933 2.80481L12.5 2.91105V7.92419C12.5 8.51231 12.3962 9.05598 12.1885 9.5552C11.9808 10.0544 11.6831 10.4852 11.2952 10.8477C10.9074 11.2101 10.4358 11.4928 9.88032 11.6957C9.32485 11.8986 8.69933 12 8.00375 12C7.30317 12 6.67515 11.8986 6.11968 11.6957C5.56422 11.4928 5.09258 11.2101 4.70475 10.8477C4.31693 10.4852 4.01918 10.0544 3.81151 9.5552C3.6335 9.1273 3.53179 8.66674 3.50636 8.17352L3.5 7.92419V2.91105L3.50673 2.80481C3.56449 2.3517 3.98716 2 4.5 2C5.01284 2 5.43551 2.3517 5.49327 2.80481L5.5 2.91105V7.91735C5.5 8.29576 5.57548 8.63769 5.68807 8.94314C5.80067 9.2486 5.9633 9.50961 6.17598 9.72616C6.38866 9.94272 6.64887 10.1103 6.95663 10.2288C7.26439 10.3473 7.61343 10.4066 8.00375 10.4066C8.39408 10.4066 8.74312 10.3473 9.05088 10.2288C9.35863 10.1103 9.6176 9.94386 9.82777 9.72958C10.0379 9.51531 10.1993 9.25544 10.3119 8.94998C10.402 8.70562 10.4683 8.43791 10.4912 8.14686L10.5 7.92419V2.91105L10.5067 2.80481C10.5645 2.3517 10.9872 2 11.5 2Z"
      fill={color}
    />
  </AccessibleSVG>
);

export default UnderlineIcon;
